import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Package } from "../../types/common.types";

interface PackageState {
  packages: Package[];
  selectedPackage: Package | null;
}

const initialState: PackageState = {
  packages: [],
  selectedPackage: null,
};

const PackageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setPackages: (state, action: PayloadAction<Package[]>) => {
      state.packages = action.payload;
    },
    addPackage: (state, action: PayloadAction<Package>) => {
      state.packages.push(action.payload);
    },
    updatePackage: (state, action: PayloadAction<Package>) => {
      const updated = action.payload;
      const index = state.packages.findIndex((pkg) => pkg.id === updated.id);
      if (index !== -1) {
        state.packages[index] = updated;
      }
    },
    updateActivePackage: (state, action: PayloadAction<Package>) => {
      const updated = action.payload;
      const index = state.packages.findIndex((pkg) => pkg.id === updated.id);
      if (index !== -1) {
        state.packages[index] = updated;
      }
    },
    removePackage: (state, action) => {
      state.packages = state.packages.filter(
        (pkg) => pkg.id !== action.payload
      );
    },
    setSelectedPackage: (state, action: PayloadAction<Package | null>) => {
      state.selectedPackage = action.payload;
    },
  },
});

export const {
  setPackages,
  addPackage,
  updatePackage,
  updateActivePackage,
  removePackage,
  setSelectedPackage,
} = PackageSlice.actions;

export default PackageSlice.reducer;
